import React from 'react'

const ChatScrollContext = React.createContext(null)

const SCROLL_DELAY = 1000

const ChatScrollProvider = ({ children }) => {
  const messageEndRef = React.useRef()
  const targetRef = React.useRef(null)
  const [scrolled, setScrolled] = React.useState(false)

  // Scroll to the bottom of the chat area
  const performScroll = React.useCallback(() => {
    if (targetRef.current) {
      targetRef.current.scrollIntoView(false)
      return
    }

    const chat = document.getElementById('chat')
    if (chat) {
      chat.scrollTop = chat.scrollHeight
    }
  }, [])

  // Scrolls to the end of messages, after rendering
  const scrollToBottom = React.useCallback(() => {
    setTimeout(() => {
      performScroll()
      setScrolled(Boolean(targetRef.current || document.getElementById('chat')))
    }, SCROLL_DELAY)
  }, [performScroll])

  // Scroll to bottom instantly
  const quickScrollToBottom = React.useCallback(() => {
    performScroll()
  }, [performScroll])

  return (
    <ChatScrollContext.Provider
      value={{
        messageEndRef,
        targetRef,
        scrolled,
        setScrolled,
        scrollToBottom,
        quickScrollToBottom
      }}
    >
      {children}
    </ChatScrollContext.Provider>
  )
}

export default ChatScrollProvider

export const useChatScroll = () => React.useContext(ChatScrollContext)
